import Icon from '../components/Icon.vue'

Icon.register({
  'business-time': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496 224C416.4 224 352 288.4 352 368S416.4 512 496 512 640 447.6 640 368 575.6 224 496 224zM560 374.3C560 379.6 555.6 384 550.3 384H489.7C484.4 384 480 379.6 480 374.3V297.7C480 292.4 484.4 288 489.7 288H502.3C507.6 288 512 292.4 512 297.7V352H550.3C555.6 352 560 356.4 560 361.7V374.3zM496 192C501.4 192 506.7 192.3 512 192.8V144C512 118.4 489.6 96 464 96H384V48C384 22.4 361.6 0 336 0H176C150.4 0 128 22.4 128 48V96H48C22.4 96 0 118.4 0 144V224H395.1C423.7 203.9 458.5 192 496 192zM320 96H192V64H320V96zM326.8 320H208C199.2 320 192 312.8 192 304V256H0V400C0 425.6 22.4 448 48 448H339.4C327.1 424 320 396.8 320 368 320 351.3 322.5 335.3 326.8 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/business-time.js
// module id = X8Y/
// module chunks = 144